class OnBoardingService {
    constructor(restangular, settings, analyticsService) {
        this.api = restangular.one('UserPreferences');
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.init();
    }

    init() {
        this.currentlySubscribedToEsc = null;
        this.bannerUrl = this.settings.onBoarding.bannerImageUrl;
        this.content = this.settings.onBoarding.content;
    }

    setOnboardingPreference(newValue) {
        this.api.one('HasDoneOnboardingPreference').doPOST({
            Value: newValue,
        });
    }

    getDynamicUserPreferences() {
        return this.api.doGET().then(response => response);
    }
}

OnBoardingService.$inject = ['Restangular', 'Settings', 'AnalyticsService'];

module.exports = OnBoardingService;



// WEBPACK FOOTER //
// ./src/shop/onboarding/onboarding.service.js